import React, { FC } from 'react';

import { DropdownSelectProps } from '@components/Dropdown/DropdownInterface';
import useSearchBar from '@contexts/searchbar';
import {
  FlightSearchBarActionType,
  IFlightSearchBarState,
} from '@contexts/searchbar/types/flight';
import Dropdown from '@components/Dropdown';
import { useBreakpoint } from '@contexts/breakpoints';

import { StyledTypography, Wrapper } from './styled';

interface ICabinClassOption {
  key: string;
  label: string;
}

export const CABIN_CLASS_OPTION: ICabinClassOption[] = [
  { key: 'All', label: 'Tümü' },
  { key: 'Business', label: 'Business' },
  { key: 'Economy', label: 'Ekonomi' },
];
export type IDropdownsGender = DropdownSelectProps<ICabinClassOption>;
const FlightCabinClass: FC<IDropdownsGender> = ({
  onChange = () => null,
  ...rest
}) => {
  const { xl: isDesktop } = useBreakpoint();

  const {
    dispatch,
    state: { flight },
  } = useSearchBar();

  const handleChange = (selectedOption: ICabinClassOption) => {
    const currentCabinClass = selectedOption
      ? (selectedOption.key as IFlightSearchBarState['cabinClass'])
      : ('All' as IFlightSearchBarState['cabinClass']);

    dispatch({
      type: FlightSearchBarActionType.SET_CABIN_CLASS,
      payload: currentCabinClass,
    });

    if (onChange) {
      onChange(selectedOption);
    }
  };
  return (
    <Wrapper>
      <Dropdown
        height={isDesktop ? '40px' : '56px'}
        items={CABIN_CLASS_OPTION}
        renderLabel={(p) => (
          <StyledTypography>{!p ? 'Tümü' : p.label}</StyledTypography>
        )}
        renderOption={(p) => p.label}
        defaultSelectedItem={CABIN_CLASS_OPTION.find(
          (p) => p.key === flight.cabinClass
        )}
        onChange={handleChange}
        customBackgroundColor='white'
        {...rest}
      />
    </Wrapper>
  );
};

export default FlightCabinClass;
